/** Shared pricing translation shape — imported by all locale files. */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const pricingTranslationsEs = {
  eyebrow: 'Paquetes y precios',
  perMonth: 'al mes',
  perYear: 'al año',
  copy: {
    pageTitle: 'Planes y precios',
    pageSubtitle:
      'Un solo lugar para comparar planes. Hobby es gratis para todos. Pro es una suscripción personal. Business es una tarifa única de org WC 2026 (no Pro). Enterprise se negocia con nuestro equipo.',
    comingSoonBadge: 'Próximamente',
    comingSoonInProduction: 'Próximamente en producción',
    mostPopularBadge: 'Más popular',
    currentPlanBadge: 'Tu plan',
    createOrgCta: 'Crear organización',
    footnote:
      'Pro se factura a tu cuenta personal (sin org). Business es una tarifa única de organización WC 2026: crea una org, elige tu nivel de plazas y paga una vez por el acceso org durante el torneo. Enterprise es para organizaciones que necesitan precios, límites o contratos personalizados — contáctanos.',
    orgPlanDisclosure: WC2026_ORG_BILLING_DISCLOSURE,
    orgPlanDisclosureShort: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    footnoteCancelPolicy:
      'Si cancelas Pro en el portal de facturación, Stripe mantiene tu plan activo hasta el final del periodo pagado — puedes reanudarlo antes de esa fecha. La app se sincroniza con Stripe cuando vuelvas aquí.',
    signInToSubscribe: 'Inicia sesión para suscribirte',
    logIn: 'Iniciar sesión',
    goBack: 'Volver',
    manageSubscription: 'Gestionar suscripción',
    proAccessEndsOn: 'El acceso Pro termina el',
    billingIntervalMonth: 'Mensual',
    billingIntervalYear: 'Anual',
    switchToMonthly: 'Cambiar a mensual',
    upgradeToYearlyDialogMsg:
      'La facturación anual es un compromiso de 12 meses. Una vez cambiado, no podrás volver a la facturación mensual hasta que termine tu periodo anual — sin reembolsos parciales.',
    upgradeToYearlyDialogConfirm: 'Cambiar a anual',
    upgradeToYearlyDialogCancel: 'Mantener mensual',
    switchToMonthlyDialogTitle: 'Cambiar a Pro mensual',
    switchToMonthlyDialogMsg:
      'Serás redirigido a Stripe para cambiar a facturación mensual. Tu acceso Pro anual continúa hasta el final del periodo actual — la facturación mensual empieza después. Sin reembolso por tiempo no usado.',
    switchToMonthlyConfirm: 'Ir a Stripe',
    switchToMonthlyCancel: 'Mantener anual',
    upgradeToYearlyProTitle: 'Actualizar a Pro anual',
    upgradeToYearlyProConfirm: 'Actualizar',
    enterpriseSubscribe: 'Suscribirse',
    enterpriseCheckoutAdminOnly: 'Pide a un admin de la org que se suscriba',
    upgradeSeatBucket: 'Actualizar',
    managePlan: 'Plan y facturación',
    businessSubscribe: 'Suscribirse',
    upgradeMonthlyToYearlyDialog: {
      line1: 'Estás cambiando de Pro mensual ({monthly}/mes) a Pro anual ({yearly}/año).',
      line2:
        'Se cargará a tu método de pago existente la diferencia prorrateada del periodo de facturación actual.',
      line3:
        'Una vez en anual, no podrás volver a la facturación mensual hasta que termine el periodo anual.',
      line4: '¿Continuar?',
    },
  },
  plans: {
    hobby: {
      name: 'Hobby',
      priceLabel: 'Gratis',
      tagline: 'Para amigos y grupos pequeños que empiezan.',
      ctaLabel: 'Empezar',
      features: [
        'Desafíos y predicciones básicos',
        'Puntuación estándar (sin dobles)',
        'Filas de partidos estándar por desafío',
        'Soporte estándar',
        'Anuncios ocasionales',
        'Ideal para probar Zporti con pocas personas',
      ],
    },
    proMonthly: {
      name: 'Pro · Mensual',
      tagline: 'Para jugadores individuales y grupos de amigos que quieren más funciones.',
      ctaLabel: 'Suscribirse mensualmente',
      features: [
        'Todo lo de Hobby',
        'Dobles habilitados',
        'Más filas de partidos por desafío',
        'Experiencia sin anuncios',
        'Límites más altos para miembros y actividad',
        'Soporte prioritario',
        'Opciones de marca más potentes',
      ],
    },
    proYearly: {
      name: 'Pro · Anual',
      tagline: 'Las mismas funciones Pro, facturadas una vez al año — ideal si tu grupo va a largo plazo.',
      ctaLabel: 'Suscribirse anualmente',
      features: [
        'Todo lo de Hobby',
        'Dobles habilitados',
        'Más filas de partidos por desafío',
        'Experiencia sin anuncios',
        'Límites más altos para miembros y actividad',
        'Soporte prioritario',
        'Opciones de marca más potentes',
      ],
    },
    business: {
      name: 'Business',
      priceLabel: 'From $450',
      tagline: 'Tarifa única de org WC 2026. Elige tu nivel de plazas y paga una vez por el acceso al torneo.',
      ctaLabel: 'Empezar',
      features: [
        'Marca organizacional (colores y logos)',
        'Plazas para miembros — niveles fijos hasta 2.000',
        'Acceso org al torneo WC 2026 (org con marca + equipo vinculado)',
        'Soporte prioritario',
        'No incluye Pro personal, monedas, boosts ni compras en la tienda de la app',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      priceLabel: 'Personalizado',
      tagline: 'Precios y despliegue org negociados para WC 2026 — definidos en tu pedido o contrato.',
      ctaLabel: 'Contáctanos',
      features: [
        'Marca y despliegue organizacional (según acuerdo)',
        'Límites de miembros acordados con ventas',
        'Funciones de WC 2026 y a nivel org (según acuerdo)',
        'Soporte dedicado e incorporación personalizada',
        'Integraciones, facturación y contratos personalizados',
        'No incluye Pro personal, monedas, boosts ni compras en la tienda de la app',
      ],
    },
  },
  seatBuckets: {
    upTo100: 'Hasta 100 empleados',
    upTo250: 'Hasta 250 empleados',
    upTo500: 'Hasta 500 empleados',
    upTo1000: 'Hasta 1.000 empleados',
    upTo2000: 'Hasta 2.000 empleados',
  },
} as const

export const featuresSectionEs = {
  eyebrow: 'Lo que obtienes',
  livePreview: 'Vista previa en vivo',
  avatars: {
    title: 'Avatares personalizados para cada jugador',
    description:
      'Dale a cada persona una identidad reconocible para que clasificaciones, rivalidades y bromas se sientan personales desde el primer día.',
    accessibilityLabel: 'Vista previa de la función de avatares personalizados',
  },
} as const

export const footerExtendedEs = {
  product: 'Producto',
  compete: 'Competir',
  company: 'Empresa',
  phoneTagline: 'Predicciones deportivas con amigos.',
  copyright: '© 2026 Zporti. Hecho por aficionados al fútbol, para aficionados al fútbol.',
  copyrightShort: '© 2026 Zporti',
} as const

export const organizationsEs = {
  heroBadge: 'Para equipos, ligas y marcas',
  heroTitle: 'Organizaciones en Zporti',
  heroLead:
    'Gestiona tu grupo con su propia identidad dentro de Zporti. Define colores y logos de marca, invita miembros con un código de acceso y administra plazas desde un solo lugar — para que todos vean una experiencia coherente al jugar y predecir juntos.',
  valueSectionTitle: 'Lo que obtienes',
  valueBrandingTitle: 'Una marca que se siente tuya',
  valueBrandingBody:
    'Sube tus logos, elige colores primarios y secundarios, y previsualiza cómo se ven en la experiencia. Los admins mantienen la apariencia consistente sin tocar código.',
  valueMembersTitle: 'Miembros y plazas',
  valueMembersBody:
    'Crea una organización o únete con un código. Ve quién está dentro, gestiona la capacidad con límites de plazas según tu plan, y copia un código de acceso al incorporar gente nueva.',
  valueMascotTitle: 'Mascota y avatares con marca',
  valueMascotBody:
    'Estados de ánimo opcionales de mascota con marca y conjuntos de avatares exclusivos de la organización ayudan a que tu comunidad destaque — ideal para grupos de fans, ligas de empresa y partners.',
  howSectionTitle: 'Cómo funciona',
  howStep1: 'Inicia sesión, luego crea una organización o únete con un código de invitación de tu admin.',
  howStep2: 'Los admins abren la configuración de la organización para ajustar marca, miembros y datos de la cuenta.',
  howStep3: 'Los miembros usan la app como siempre, con los visuales y beneficios de tu organización donde estén habilitados.',
  signIn: 'Iniciar sesión',
  signUp: 'Crear cuenta',
  heroPanelTitle: 'Sala de control de la organización',
  heroPanelBody:
    'Invita miembros, define la marca y ofrece a cada grupo un hogar pulido antes del pitido inicial.',
} as const

export const b2bContactEs = {
  title: '¿Prefieres que lo configuremos por ti?',
  subtitle: 'Completa tus datos y nuestro equipo se pondrá en contacto.',
  orgNameLabel: 'Nombre de la organización *',
  orgNamePlaceholder: 'Tu organización',
  contactNameLabel: 'Tu nombre *',
  contactNamePlaceholder: 'Nombre completo',
  emailLabel: 'Correo electrónico *',
  emailPlaceholder: 'tu@ejemplo.com',
  messageLabel: 'Mensaje',
  messagePlaceholder: 'Cuéntanos tus necesidades (opcional)',
  submitButton: 'Enviar solicitud',
  scheduleMemo: 'O agenda una llamada — próximamente',
  errorFallbackValidation: 'Revisa tu información e inténtalo de nuevo.',
  errorFallbackSubmit: 'No se pudo enviar. Inténtalo de nuevo.',
  successMessage: '¡Gracias! Recibimos tu solicitud y nos pondremos en contacto pronto.',
} as const

export const signInEs = {
  signUpSubtitle: 'Regístrate para empezar',
  signInSubtitle: 'Inicia sesión para continuar',
  emailPlaceholder: 'Correo electrónico',
  passwordPlaceholder: 'Contraseña',
  forgotPassword: '¿Olvidaste tu contraseña?',
  signUpButton: 'Registrarse',
  signInButton: 'Iniciar sesión',
  alreadyHaveAccount: '¿Ya tienes cuenta? ',
  noAccount: '¿No tienes cuenta? ',
  toggleSignIn: 'Iniciar sesión',
  toggleSignUp: 'Registrarse',
  orDivider: 'O',
  signInWith: 'Iniciar sesión con',
  continueAsGuest: 'o continuar como invitado',
  legalConsentPrefix: 'He leído y acepto los ',
  legalConsentAnd: ' y la ',
  legalConsentSuffix: '.',
  marketingConsent: 'Acepto recibir actualizaciones del producto y correos de marketing de Zporti.',
  loading: 'Cargando…',
  sendingResetEmail: 'Enviando correo de restablecimiento',
  signingUp: 'Registrando',
  signingIn: 'Iniciando sesión',
  continuingWithGoogle: 'Continuando con Google',
  continuingWithFacebook: 'Continuando con Facebook',
  enteringAsGuest: 'Entrando como invitado',
} as const

export const a11yEs = {
  openMenu: 'Abrir menú',
  closeMenu: 'Cerrar menú',
  heroMascot: 'Mascota de Zporti sosteniendo un teléfono',
} as const

export const accountAdminSiteEs = {
  backToSite: '← Volver al sitio',
} as const
